exports = module.exports = require("../../../node_modules/.0.28.0@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".box {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  background-size: 50px 50px; }\n\n.people {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  background-size: 50px 50px; }\n", "", {"version":3,"sources":["E:/h5star/feifanh5star/src/common/sass/E:\\h5star\\feifanh5star/src\\common\\sass\\scence.scss"],"names":[],"mappings":"AACA;EACI,mBAAkB;EAClB,YAHO;EAIP,aAJO;EAKP,2BALO,EAMV;;AAED;EACI,mBAAkB;EAClB,YAVO;EAWP,aAXO;EAYP,2BAZO,EAaV","file":"scence.scss","sourcesContent":["$base: 50px;\r\n.box {\r\n    position: absolute;\r\n    width: $base;\r\n    height: $base;\r\n    background-size: $base $base;\r\n}\r\n\r\n.people {\r\n    position: absolute;\r\n    width: $base;\r\n    height: $base;\r\n    background-size: $base $base;\r\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.28.0@css-loader?sourceMap!./~/.1.3.3@postcss-loader!./~/.6.0.3@sass-loader/lib/loader.js?sourceMap!./src/common/sass/scence.scss
// module id = 73
// module chunks = 0